import React, { useState, useEffect, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import { openRtbSize } from 'lib/api/code';
import { addAllList } from 'modules/common';
import { showSuccessSnackbar } from 'modules/snackbar';

import FilterCollection from 'components/organisms/FilterCollection';

const OpenRTBSizeBox = (props) => {
  const { getParams, params, getList } = props;
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const [imgSizeList, setImgSizeList] = useState([]);

  useEffect(() => {
    openRtbSize()
      .then((response) => {
        let newList = [];
        for (let size of response.data.data) {
          newList.push({ label: size['SIZE_VAL'], value: size['CODE'] });
        }
        setImgSizeList(newList);
      })
      .catch((error) => {
        handleClickSnackbar({ message: error, option: { type: 'error' } });
      }); // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (typeof getList !== 'undefined') {
      getList(imgSizeList);
    }
    // eslint-disable-next-line
  }, [imgSizeList]);

  const handleClickSnackbar = useCallback((snackbarOptions) => {
    dispatch(showSuccessSnackbar(snackbarOptions));
    //eslint-disable-next-line
  }, []);

  return (
    !!imgSizeList.length && (
      <FilterCollection
        label={t('이미지 사이즈')}
        value={params.sizeVal}
        name="sizeVal"
        type="select"
        params={params}
        list={addAllList(imgSizeList, 'label', 'value', 'all')}
        labelKey="label"
        valueKey="value"
        callBack={getParams}
      />
    )
  );
};

export default OpenRTBSizeBox;
